module.exports = __webpack_public_path__ + "img/carro3.17f26238.jpg";